$(document).ready(function() {
	if(!document.querySelector('.GPC0081')) return false;

	var c = {
		el: null,
		form: null,
		template: null,
		submitBtn : null,
		init: function(){
			var _this = c;
			var els = document.querySelectorAll('.GPC0081');
			for (var i = 0; i < els.length; i++) {
				_this.el = els[i];

				if($(_this.el.querySelector("form")).length > 0) {
					_this.form = _this.el.querySelector("form");
					_this.submitBtn = _this.form.querySelector("button[type=submit]");
					_this.template = $(_this.el).find('.contents-template').clone();
					$(_this.el).find('.contents-template').remove();

					var param = $(_this.form.baseFields).serialize();
					_this.form.downloadCategory.setAttribute('data-param', param);

					_this.submitBtn.disabled=true;
					_this.addEvent();
				}
			}
		},
		createProductItem: function(productList){
			var html = [];
			for (var i = 0; i < productList.length; i++) {
				var p = productList[i],
					template = $(c.template).clone().html();

				template = template.replace(/\*groupTitle\*/g, p.groupTitle);

				var $template = $(template),
					itemMarkup = [];

				for (var j = 0; j < p.downloadList.length; j++) {
					var currentP = p.downloadList[j],
						itemTemplate = $template.find(".item-template").clone().html();

					itemTemplate = itemTemplate.replace(/\*fileName\*/g, currentP.fileName)
											.replace(/\*extension\*/g, currentP.extension)
											.replace(/\*fileUrlPath\*/g, currentP.fileUrlPath);

					itemMarkup += itemTemplate;
				}
				$template.find(".list-group").html(itemMarkup);

				$template.find('template').remove();
				template = $template.get(0).outerHTML;
				html += template;

				//console.log(html);
			}

			return html;
		},
		addEvent: function(){
			var _this = c;
			$(_this.el).on({
				submit: function(e){
					e.preventDefault();
					var url = e.currentTarget.action,
						param = xssfilter($(e.currentTarget).serialize());
					var $target = $(e.currentTarget).closest(".component").find('.list-contents-wrap');

					if($(e.currentTarget).checkValidation()) {
						// adobe
						var $select = $(e.currentTarget).find('.ui-unit-box').not('.hidden');
						var num = $select.length;
						var adobeText = '';
						if(num>=1) adobeText = adobeText + changeTitleFormat($select.eq(0).find('select option:selected').text());
						if(num>=2) adobeText = adobeText + '_' + changeTitleFormat($select.eq(1).find('select option:selected').text());
						if(num>=3) adobeText = adobeText + '_' + changeTitleFormat($select.eq(2).find('select option:selected').text());

						adobeTrackEvent('show', {filter_name : adobeText, page_event : {filter_apply : true}});

						ajax.call(url, param, 'json', function(d){
							var data, html;
							if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;

							if(d.status == "success" && data) {
								if(data.contents && data.contents.length > 0) {
									// making markup
									html = c.createProductItem(data.contents);

									$target.find('.block-list').html(html);
									$target.siblings(".no-result").removeClass("active");
									$target.addClass("active");
								}else {
									$target.siblings(".no-result").removeClass("active");
									$target.siblings(".no-result").not('.no-model').addClass("active");
									$target.removeClass("active");
								}
							}
						}, null, '.GPC0081');
					}
				}
			}, 'form');

			$(_this.form.downloadCategory).drawAjaxOptions({
				setTarget: _this.form.downloadSub,
				empty: function(e){
					_this.form.downloadSub.disabled = true;
					$(_this.form.downloadSub).closest(".field-block").addClass("hidden");
					$(_this.form.downloadSub).append("<option value='' selected></option>")
					.trigger('change');
					$(_this.form.downloadSub).trigger("chosen:updated");

					_this.submitBtn.disabled=true;
				},
				notEmpty: function(e){
					_this.form.downloadSub.disabled = false;
					$(_this.form.downloadSub).closest(".field-block").removeClass("hidden");
					$(_this.form.downloadSub).trigger("chosen:updated");

					_this.form.downloadModel.disabled = true;
					_this.form.downloadModel.value = "";
					$(_this.form.downloadModel).closest(".field-block").addClass("hidden");
					$(_this.form.downloadModel).trigger("chosen:updated");

					_this.submitBtn.disabled=true;
				},
				dynamicParam: true,
				dataArray: "categoryList",
				keyName: "categoryName",
				keyValue: "categoryId"
			});
			// parameter setting
			$(_this.form.downloadCategory).on({
				change: function(){
					var type = $(_this.form.downloadCategory).find("option:selected").attr('data-type');
					_this.form.type.value = type;

					var param = $(_this.form).serialize();
					_this.form.downloadSub.setAttribute('data-param', param);
					
					// LGEGMC-946
					setClassificationCode(_this.form.downloadCategory.value);
					// LGEGMC-946 End
				}
			});
			// parameter setting
			$(_this.form.downloadSub).on({
				change: function(){
					var param = $(_this.form).serialize();
					_this.form.downloadModel.setAttribute('data-param', param);
					
					// LGEGMC-946
					setClassificationCode(_this.form.downloadSub.value);
					// LGEGMC-946 End
				}
			});
			// submit button activate
			$(_this.form.downloadModel).on({
				change: function(){
					var m = $(this).val();
					if(!m || m=='') {
						_this.submitBtn.disabled=true;
					} else {
						_this.submitBtn.disabled=false;
					}
				}
			});

			$(_this.form.downloadSub).drawAjaxOptions({
				setTarget: _this.form.downloadModel,
				empty: function(e){
					_this.form.downloadModel.disabled = true;
					$(_this.form.downloadModel).append('<option value="general" selected></option>');
					$(_this.form.downloadModel).closest(".field-block").addClass("hidden");
					$(_this.form.downloadModel).trigger("chosen:updated");
					_this.submitBtn.disabled=true;

					var $el = $(_this.submitBtn).closest('.GPC0081');
					$el.find(".list-contents-wrap").removeClass("active");
					// 개발반영 기다리며. 에러 안나오도록 아래와 같이 반영함. 추후 개발 반영되고 나면 수정해도 됨.
					if($el.find(".no-result.no-model").length>0) {
						$el.find(".no-result.no-model").addClass("active");
						$el.find(".no-result").not('.no-model').removeClass("active");
					} else {
						$el.find(".no-result").addClass("active");
					}
				},
				notEmpty: function(e){
					_this.form.downloadModel.disabled = false;
					_this.form.downloadModel.selectedIndex = 0;
					_this.form.downloadModel.options[0].disabled = false;
					_this.form.downloadModel.options[0].value = 'general';
					$(_this.form.downloadModel).closest(".field-block").removeClass("hidden");
					$(_this.form.downloadModel).trigger("chosen:updated");
					_this.submitBtn.disabled=true;

					var $el = $(_this.submitBtn).closest('.GPC0081');
					$el.find(".list-contents-wrap").removeClass("active");
					// 개발반영 기다리며. 에러 안나오도록 아래와 같이 반영함. 추후 개발 반영되고 나면 수정해도 됨.
					if($el.find(".no-result.no-model").length>0) {
						$el.find(".no-result").removeClass("active");
						$el.find(".no-result").not('.no-model').addClass("active");
					} else {
						$el.find(".no-result").addClass("active");
					}
				},
				dynamicParam: true,
				dataArray: "modelList",
				keyName: "modelName",
				keyValue: "value"
			});
		}
	};

	c.init();

	$('.GPC0081').on('click', '.download-item a', function() {
		var title = $(this).closest('.list-block').find('.head').text();
		if(!title) {
			title = '';
		} else {
			title = changeTitleFormat(title);
		}
		adobeTrackEvent('resource-download', {resource_download_type : title, page_event : {resource_download : true}});
	});
});

// LGEGMC-946
function setClassificationCode(categoryId){
	if(typeof standardData != 'undefined'){
		var url = '/'+COUNTRY_CODE.toLowerCase()+'/mkt/ajax/retrieveCategoryBuInfo?bizType=B2B&categoryId='+categoryId;
		$.ajax({
			type:"post",
			url: url,
			dataType: "json",
			xhrFields: {
				withCredentials: true
			},
			success: function(data) {
				standardData.level1 = data.data[0].buName.buName1;
				standardData.level2 = data.data[0].buName.buName2;
				standardData.level3 = data.data[0].buName.buName3;
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
			}
		});
	}
}
// LGEGMC-946 End